// On s'assure que le script s'exécute une fois le contenu de la page chargé
document.addEventListener('DOMContentLoaded', () => {

    // 1. Cibler le calque spécifique
    const container = document.getElementById('page_deco');

    // On vérifie que le calque existe bien sur la page pour éviter les erreurs
    if (container) {

        // 2. Sélectionner tous les liens ayant la classe "lien_interne" ET un attribut "data-anchor"
        const links = container.querySelectorAll('a.lien_interne[data-anchor]');

        // 3. Parcourir chaque lien trouvé
        links.forEach(link => {
            const currentHref = link.getAttribute('href');
            const anchor = link.getAttribute('data-anchor');

            // 4. Si le lien a un href, une valeur d'ancre, et qu'il ne contient pas déjà un "#"
            if (currentHref && anchor && !currentHref.includes('#')) {

                // On met à jour le href en ajoutant l'ancre à la fin
                link.setAttribute('href', `${currentHref}#${anchor}`);

            }
        });
    }
});